export const FETCH_FLOW24_SERVER_CONFIG = "FETCH_FLOW24_SERVER_CONFIG";

export const ADD_USER = "ADD_USER";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_PASSWORD = "EDIT_USER_PASSWORD";
export const DELETE_USER = "DELETE_USER";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_ROLES = "FETCH_ROLES";

export const ADD_NETWORK = "ADD_NETWORK";
export const EDIT_NETWORK = "EDIT_NETWORK";
export const DELETE_NETWORK = "DELETE_NETWORK";
export const FETCH_NETWORKS = "FETCH_NETWORKS";

export const ADD_RESTAURANT = "ADD_RESTAURANT";
export const EDIT_RESTAURANT = "EDIT_RESTAURANT";
export const DELETE_RESTAURANT = "DELETE_RESTAURANT";
export const FETCH_RESTAURANTS = "FETCH_RESTAURANTS";

export const EDIT_GLOBAL_PARAM = "EDIT_GLOBAL_PARAM";
export const FETCH_GLOBAL_PARAMS = "FETCH_GLOBAL_PARAMS";

export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_ME = "AUTH_ME";

export const FETCH_CONNECTIONS = "FETCH_CONNECTIONS";
export const FILTER_CONNECTIONS = "FILTER_CONNECTIONS";

export const FETCH_RESTAURANT_PAYMENTS = "FETCH_RESTAURANT_PAYMENTS";
export const CLEAR_RESTAURANT_PAYMENTS = "CLEAR_RESTAURANT_PAYMENTS";
export const FETCH_OVERDUE_PAYMENTS = "FETCH_OVERDUE_PAYMENTS";

export const ADD_P24_TRANSACTION = "ADD_P24_TRANSACTION"
export const FETCH_P24_TRANSACTIONS = "FETCH_P24_TRANSACTIONS";
export const FETCH_P24_TRANSACTION = "FETCH_P24_TRANSACTION";
export const FILTER_P24_TRANSACTIONS = "FILTER_P24_TRANSACTIONS";
export const FETCH_P24_TRANSACTION_DATA_BYP24 = "FETCH_P24_TRANSACTION_DATA_BYP24";
export const FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24 = "FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24";
export const FETCH_P24_TRANSACTION_REFUNDS = "FETCH_P24_TRANSACTION_REFUNDS";
export const PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_P24_TRANSACTION = "PAYMENT_METHOD_BLIK_CHARGE_BY_CODE_P24_TRANSACTION";
export const REFUND_P24_TRANSACTION = "REFUND_P24_TRANSACTION";

export const FETCH_P24_TRANSACTION_LOGS = "FETCH_P24_TRANSACTION_LOGS";

export const FETCH_P24_RESTAURANT_CHEQUE_TRANSACTIONS = "FETCH_P24_RESTAURANT_CHEQUE_TRANSACTIONS";
export const FILTER_P24_RESTAURANT_CHEQUE_TRANSACTIONS = "FILTER_P24_RESTAURANT_CHEQUE_TRANSACTIONS";

export const FETCH_P24_RESTAURANT_LOGS = "FETCH_P24_RESTAURANT_LOGS";
export const FILTER_P24_RESTAURANT_LOGS = "FILTER_P24_RESTAURANT_LOGS";

export const FETCH_P24_RESTAURANT_MERCHANT = "FETCH_P24_RESTAURANT_MERCHANT";
export const CLEAR_P24_RESTAURANT_MERCHANT = "CLEAR_P24_RESTAURANT_MERCHANT";
export const ADD_P24_RESTAURANT_MERCHANT = "ADD_P24_RESTAURANT_MERCHANT"

export const FETCH_P24_MERCHANTS_BY_NIP = "FETCH_P24_MERCHANTS_BY_NIP"
export const FETCH_P24_MERCHANTS_BY_PESEL = "FETCH_P24_MERCHANTS_BY_PESEL"
export const FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID = "FETCH_P24_MERCHANTS_BY_P24_MERCHANT_ID"

export const ADD_P24_MERCHANT = "ADD_P24_MERCHANT"
export const EDIT_P24_MERCHANT = "EDIT_P24_MERCHANT"
export const DELETE_P24_MERCHANT = "DELETE_P24_MERCHANT"
export const FETCH_P24_MERCHANTS = "FETCH_P24_MERCHANTS";
export const FETCH_P24_MERCHANT_BY_ID = "FETCH_P24_MERCHANT_BY_ID";
export const ATTACH_P24_RESTAURANT_MERCHANT = "ATTACH_P24_RESTAURANT_MERCHANT";
export const DETACH_P24_RESTAURANT_MERCHANT = "DETACH_P24_RESTAURANT_MERCHANT";
export const TEST_CONNECTION_P24_MERCHANT = "TEST_CONNECTION_P24_MERCHANT";
export const FETCH_P24_MERCHANT_PAYMENT_METHODS = "FETCH_P24_MERCHANT_PAYMENT_METHODS";

export const FETCH_P24_LOGS = "FETCH_P24_LOGS";
export const FILTER_P24_LOGS = "FILTER_P24_LOGS";